import type { MondaySettingsData } from "@sr-partner-portal/common";
import { createContext, useContext } from "react";

interface MondaySettingsDataContext {
    mondaySettingsData: Omit<
        MondaySettingsData,
        "id" | "createdAt" | "updatedAt"
    > | null;
}

export const MondaySettingsDataContext =
    createContext<MondaySettingsDataContext>({
        mondaySettingsData: null,
    });
export const MondaySettingsDataProvider = MondaySettingsDataContext.Provider;
export const useMondaySettingsDataContext = () =>
    useContext(MondaySettingsDataContext);

export const defaultMondaySettingsData: MondaySettingsDataContext["mondaySettingsData"] =
    {
        employeeBenefits: [],
        employeeRequirements: [],
        traineeBenefits: [],
        traineeRequirements: [],
        traineeProfessionsAndSpecializations: [],
        dualStudentBenefits: [],
        dualStudentRequirements: [],
        faqEmployeeTemplates: [],
        faqTraineeTemplates: [],
    };
